import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { AuthService, FavouriteProductListConfigService, FavouriteProductsService, Product, ProductListConfigService, ProductService } from 'gung-standard';
import { SjoborgProductPaginationListTableComponent } from '../components/sjoborg-product-pagination-list-table/sjoborg-product-pagination-list-table.component';
import { SjoborgProductGridViewComponent } from '../components/sjoborg-product-grid-view/sjoborg-product-grid-view.component';

@Injectable({
  providedIn: 'root'
})
export class SjoborgFavouriteProductListConfigService extends FavouriteProductListConfigService {


  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => 'fa fa-th',
        getListItemComponent: () => SjoborgProductGridViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      },
      {
        getIconClass: () => 'fa fa-list',
        getListItemComponent: () => SjoborgProductPaginationListTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductList'
      }
    ];
  }
}
